exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#social-icons {\n    text-align: center;\n}\n\n.fa-facebook {\n    background: #3B5998;\n    color: white;\n}\n\n.fa-twitter {\n    background: #55ACEE;\n    color: white;\n}\n\n.fa-instagram {\n    background: #125688;\n    color: white;\n}\n\n.fa:hover {\n    opacity: 0.7;\n}\n\n.fa {\n    padding: 5px;\n    font-size: 15px;\n    width: 25px;\n    margin: 5px 3px;\n    border-radius: 50%;\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/social-icons/social-icons.component.css
// module id = 382
// module chunks = 1